import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Loader2, BellRing, BellOff } from "lucide-react";
import { Brand } from "@/components/Brand";
import { DisclosureFooter } from "@/components/FundingDisclosure";

import { api, formatErr } from "@/lib/api";

export default function SavedSearchAction() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const action = params.get("action") === "unsubscribe" ? "unsubscribe" : "confirm";
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.post(`/saved-searches/${token}/${action}`).then((r) => setRes(r.data)).catch((e) => setErr(formatErr(e))); }, [token, action]);
  const Icon = action === "unsubscribe" ? BellOff : BellRing;
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200"><div className="max-w-3xl mx-auto px-6 h-16 flex items-center"><Brand /></div></header>
      <main className="max-w-xl mx-auto px-6 py-20 text-center" data-testid="saved-search-action">
        {!res && !err ? <Loader2 className="h-6 w-6 animate-spin text-emerald-600 mx-auto" /> : <>
          <Icon className={`h-10 w-10 mx-auto ${err ? "text-slate-400" : "text-emerald-600"}`} />
          <h1 className="font-display text-3xl font-extrabold text-slate-900 mt-4" data-testid="saved-search-result">
            {err ? "Link not valid" : action === "unsubscribe" ? "You're unsubscribed" : "Alert confirmed"}
          </h1>
          <p className="text-slate-600 mt-3">{err || (action === "unsubscribe" ? `You won't get more emails for "${res.label}".` : `We'll email you a daily summary when new businesses matching "${res.label}" are verified.`)}</p>
          <Link to="/verified" className="inline-block mt-6 text-emerald-700 font-semibold" data-testid="saved-search-back-link">Back to the directory →</Link>
        </>}
      </main>
      <DisclosureFooter />
    </div>
  );
}
